export default __webpack_public_path__ + "static/media/bg1.9ba2bca3.png";